import { Mail, MapPinHouse, Phone } from "lucide-react";


export default function Contact() {
  return (
    <div className="w-[80%] mx-auto lg:h-[60dvh]">
      <h2 className="font-bold text-4xl my-4 text-center text-sky-500">
        Contact
      </h2>
      <div className="lg:grid grid-cols-3 mt-12 flex flex-col gap-8">
        <div className="">
          <div className="flex gap-3 items-center justify-center p-4 bg-sky-100 rounded-lg border border-sky-300">
            <div className="">
              <Phone size={32} className="text-sky-500" />
            </div>
            <div className="text-center">
              <h3 className="text-2xl text-sky-500 mb-3">Phone</h3>
              <p className=" text-sky-500">+91 3617968083</p>
              <p className=" text-sky-500">
                10am-6pm, Mon-Fri, except holidays
              </p>
            </div>
          </div>
        </div>
        <div className="">
          <div className="flex gap-3 items-center justify-center p-4 bg-sky-100 rounded-lg border border-sky-300">
            <div className="">
              <Mail size={32} className="text-sky-500" />
            </div>
            <div className="text-center">
              <h3 className="text-2xl text-sky-500 mb-3">Email</h3>
              <p className=" text-sky-500">nhwm.oh@gmail.com</p>
              <p className=" text-sky-500">nhwm.info@gmail.com</p>
            </div>
          </div>
        </div>
        <div className="">
          <div className="flex gap-3 items-center justify-center p-4 bg-sky-100 rounded-lg border border-sky-300">
            <div className="">
              <MapPinHouse size={32} className="text-sky-500" />
            </div>
            <div className="text-center">
              <h3 className="text-2xl text-sky-500 mb-3">Location</h3>
              <p className=" text-sky-500">
                Dr. Zakir Hussain Road, Hengrabari, Guwahati,
              </p>
              <p className=" text-sky-500">Assam – 781036, India</p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-6"></div>
      {/* Start Google Map */}
      <div className="h-[300px] mx-auto w-full">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3581.4444896330488!2d91.80171077619283!3d26.149649777110326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s16%2C%20R.K.%20Kakati%20Path%2C%20Dr.%20Zakir%20Hussain%20Road%2C%20Near%20Nabajyoti%20Club%2C%20Hengrabari%2C%20Guwahati%2C%20Assam%20%E2%80%93%20781036!5e0!3m2!1sen!2sin!4v1738394302997!5m2!1sen!2sin"
          loading="lazy"
          // referrerpolicy="no-referrer-when-downgrade"
          className="w-full h-full"
        ></iframe>
      </div>
      {/* End Google Map */}
      <div className="w-full h-[3rem]"></div>
    </div>
  );
}
